const ContactHero = () => (
  <div className="bg-[#0A1628] relative overflow-hidden">
    <div className="absolute inset-0 opacity-10">
      <div className="absolute top-0 left-1/4 w-96 h-96 rounded-full bg-violet-500 blur-3xl" />
      <div className="absolute bottom-0 right-1/4 w-72 h-72 rounded-full bg-indigo-400 blur-3xl" />
    </div>

    <div className="max-w-7xl mx-auto px-6 py-16 relative">
      <div className="max-w-2xl mx-auto text-center">
        <span className="text-xs font-semibold text-violet-400 tracking-widest uppercase mb-4 block">
          合作 · 入駐 · 學員支援
        </span>
        <h1 className="text-4xl font-bold text-white mb-4 tracking-tight leading-tight">
          無論你是誰，<br />我們都在這裡
        </h1>
        <p className="text-slate-400 text-sm leading-relaxed mb-8">
          希望與我們共同賦能人才的企業夥伴、想分享經驗幫助學員成長的業界導師，
          或是遇到問題需要協助的在讀學員——找到你的入口，直接聯絡我們。
        </p>

        <div className="flex items-center justify-center gap-8">
          {[
            { icon: 'ri-building-line', value: '50+', label: '合作企業' },
            { icon: 'ri-user-star-line', value: '500+', label: '認證導師' },
            { icon: 'ri-trophy-line', value: '1,200+', label: '成功學員' },
          ].map((s) => (
            <div key={s.label} className="text-center">
              <div className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-xl mx-auto mb-2">
                <i className={`${s.icon} text-violet-400 text-lg`} />
              </div>
              <p className="text-xl font-bold text-white">{s.value}</p>
              <p className="text-slate-400 text-xs mt-0.5">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default ContactHero;
